import React from 'react'
import Carousel from 'react-bootstrap/Carousel'
import './slider.scss'

const UncontrolledCarouselExample: React.FC = () => {
  return (
    <div className='h-100'>
      <Carousel interval={6000}>
        <Carousel.Item>
          <img
            className='d-block w-100 h-100'
            src='/media/login-bg/energy-blockchain.jpg'
            alt='First slide'
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className='d-block w-100 h-100'
            src='/media/login-bg/blockchain-img.png'
            alt='Second slide'
          />
        </Carousel.Item>
      </Carousel>
    </div>
  )
}

export default UncontrolledCarouselExample
